<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9KSytn/tc-custom/9781945547577.jpg?1721442278213" alt="This image is the cover for the book 101 Amazing Uses for Coconut Oil"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">101 Amazing Uses for Coconut Oil
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover surprising and practical uses for this flavorful, antibacterial oil—from soothing burns and whitening your teeth to removing makeup.</b><br/><br/>Coconut oil is a well-known super food, but the benefits extend far beyond the kitchen. In <i>101 Amazing Uses for Coconut Oil</i>, nutrition consultant reveals how this widely available product can boost your metabolism, heal cold sores, reduce hypertension, and so much more.<br/><br/>Branson’s <i>101 Amazing Uses</i> series reveals the practical yet little-known uses for common natural products, including ginger, aloe vera, apple cider vinegar and more. Each book is filled with easy-to-read, bite-sized benefits for everything from health to beauty to household cleaning.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Branson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Familius Llc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?354a2b2c